import {Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {ReactorLogFilter} from "./reactorLog.filter";
import { debounceTime } from 'rxjs/operators';
import {UsageFilter} from "../usage/usage.filter";

@Component({
  selector: 'micro-reactor-logs',
  templateUrl: './reactor-logs.component.html'
})
export class ReactorLogsComponent implements OnInit, OnDestroy  {

  @Input()
  reactorId:any;

  @Input()
  eventType:string;

  @Input()
  eventSource:string;

  @Input()
  selectionMode:string;

  @Input()
  selectedRow:any;

  @Output()
  selectedRowChange:EventEmitter<any> = new EventEmitter<any>();

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns:string[] = ['datetime','input','evalLog','error'];
  filter:ReactorLogFilter = new ReactorLogFilter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  timer:any;
  autoRefresh:boolean;
  reloading:boolean = false;
  usageFilter:UsageFilter = new UsageFilter();

  selectedId:any;

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
  }

  ngOnInit() {
    this.filter.eventType = this.eventType;
    this.filter.eventSource = this.eventSource;
    if (this.reactorId) {
      this.filter.reactorId = this.reactorId;
    }

    this.timer = setInterval(()=> {
      if (this.autoRefresh) {
        this.reload();
      }
    }, 30000);
    this.usageFilter.anyChange.pipe().pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.paginator.pageIndex = 0;
      this.reload();
    });
    this.reload();
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  onSelectedRowChange() {
    this.selectedRowChange.emit(this.selectedRow);
  }

  getChartFilter() {
    if (this.reactorId) {
      return `reactorId = '${this.reactorId}'`;
    }
    return '';
  }

  reload() {
    if (this.reloading) {
      return;
    }

    this.reloading = true;
    let params:HttpParams = this.filter.getParams()
      .set("page", '' + (this.paginator.pageIndex || 0))
      .set("size", '' + (this.paginator.pageSize || 20))
    ;

    if (!this.usageFilter.fromInfinite) {
      params = params.set('from', '' + this.usageFilter.from);
    }

    if (!this.usageFilter.untilInfinite) {
      params = params.set('until', '' + this.usageFilter.until);
    }

    this.http.get(`${this.env.e.url}/reactor/logs`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
        this.reloading = false;
      }
    );
  }
}
